/**
 * Created by Ramon Wenger on 07.08.18.
 * Copyright (c) 2018 Iterativ GmbH. All rights reserved.
 */
import { TranslateModule } from "@ngx-translate/core";
import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { SubscriptionInfoComponent } from "./subscription-info.component";
import { RouterModule } from "@angular/router";


@NgModule(
    {
        imports: [
            TranslateModule,
            CommonModule,
            RouterModule
        ],
        declarations: [ SubscriptionInfoComponent ],
        providers: [ DatePipe ],
        exports: [ SubscriptionInfoComponent ]
    })
export class SubscriptionModule {
}
